module.exports = __webpack_public_path__ + "static/media/flaskFull.aaf75920.svg";